import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { useGetEmployeeById } from '@/modules/employee/Employee/hooks';
import { CardDetails } from '@/modules/transaction/CardDetails/CardDetails';
import theme from '@/styles/theme';

const CardDetailsPage = () => {
  const { data: employeeData, id } = useGetEmployeeById();
  const fullName = useMemo(
    () => `${employeeData?.firstName} ${employeeData?.lastName}`.trim(),
    [employeeData]
  );
  useBreadcrumbs(
    [
      {
        route: ROUTES.EMPLOYEES,
        title: 'Employees',
      },
      {
        route: ROUTES.EMPLOYEE_VIEW(id),
        title: fullName,
      },
      {
        route: ROUTES.CARD_DETAILS,
        title: 'Card details',
      },
    ],
    [fullName],
    { backBtn: true }
  );

  return (
    <Box width="100%" margin={{ top: '0' }} height="fit-content">
      <Topbar />
      <Box align="center" pad={{ bottom: 'spacing72' }}>
        <Box width={theme.defaultContentWidth}>
          <CardDetails isShipmentTrackerMode />
        </Box>
      </Box>
    </Box>
  );
};

export default CardDetailsPage;
